const findById = function (data, id) {
    let ret = undefined;
    for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
            return data[i];
        } else if (data[i].children && data[i].children.length && typeof data[i].children === 'object') {
            ret = findById(data[i].children, id);
            if (ret && ret.id === id) {
                return ret;
            }
        }
    }
    return ret;
};

const cloneArray = function (dataArray) {
    return JSON.parse(JSON.stringify(dataArray));
};

const transformToOneLevel = function (model) {
    let newModel = {};
    for (const key in model) {
        if (typeof model[key] === 'object' && model[key] !== null) {
            for (const keyInner in model[key]) {
                newModel[key + '.' + keyInner] = model[key][keyInner];
            }
            // delete model[key];
        } else if (typeof model[key] !== 'object') {
            newModel[key] = model[key];
        }
    }
    return newModel;
};

function objectToBase64String(object) {
    return Buffer.from(JSON.stringify(object)).toString('base64');
}
function abbreviateNumber(value) {
    var newValue = value;
    if (value >= 1000) {
        var suffixes = ['', 'k', 'm', 'b', 't'];
        var suffixNum = Math.floor(('' + value).length / 3);
        var shortValue = '';
        for (var precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat((suffixNum != 0 ? value / Math.pow(1000, suffixNum) : value).toPrecision(precision));
            var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '');
            if (dotLessShortValue.length <= 2) {
                break;
            }
        }
        if (shortValue % 1 != 0) var shortNum = shortValue.toFixed(1);
        newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
}

// const debounce = (func, delay) => {
//     let inDebounce
//     return function () {
//         const context = this
//         const args = arguments
//         clearTimeout(inDebounce)
//         inDebounce = setTimeout(() => func.apply(context, args), delay)
//     }
// }


function debounce(func) {
    let timer;
    return function (timeout) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func();
        }, timeout);
    };
}

/**
 * Превращает строки в schema.schema.fields в функцию
 * @param {Object} schema - Схема заявки
 * **/
function parseFunctionsFromSchema(schema){
    // Все ключи в fields которые могут быть функцией
    const FUNC_FIELDS = ['set', 'get', 'onChanged', 'onValidated', 'visible', 'disabled', 'readonly', 'featured'];

    const clonedSchema = JSON.parse(JSON.stringify(schema));

    if (!clonedSchema || !clonedSchema.schema || !clonedSchema.schema.fields) return clonedSchema;

    clonedSchema.schema.fields.forEach(field => {
        FUNC_FIELDS.forEach(objKey => {
            if (field.hasOwnProperty(objKey) && typeof field[objKey] === 'object' && field[objKey].isFunction) {
                field[objKey] = new Function(field[objKey].args, field[objKey].body);
            }
        });
    });

    return clonedSchema;
}

export { findById, cloneArray, transformToOneLevel, objectToBase64String, abbreviateNumber, debounce, parseFunctionsFromSchema };
